import axios from 'axios'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import ExternalLayout from '../../layout/External'
import { AUTH_USER_FIRSTSIGNUP } from '../../redux/actions/actionTypes'
import { signIn, signUp } from '../../redux/actions/authentication'
import { v4 as uuidv4 } from 'uuid'
import jwtDecode from 'jwt-decode'
import { FaRegQuestionCircle } from 'react-icons/fa'
import Tooltip from '../../components/Display/Tooltip'
import Modal from '../../components/Display/Modal'
import { BsFillCircleFill } from 'react-icons/bs'
import { AuthService } from '../../services/AuthService'

const server = process.env.REACT_APP_SERVER_URL

let authInstance = new AuthService()

const RegisterFirst = () => {
  const form = useForm()

  const history = useHistory()

  const [agree, setAgree] = useState<boolean>(false)

  const [emailAlreadyExist, setEmailAlreadyExist] = useState<boolean>(false)

  const { addAlert } = useSnackBars()

  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState<boolean>(false)

  const plansType = [
    { text: 'Emprendedor', value: 'emprendedor' },
    { text: 'PYME', value: 'pyme'},
    {
      text: 'Corporativo',
      value: 'corporativo',
    },
    { text: 'Estudiantil', value: 'estudiantil' },
  ]

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  /** Contraseña debe de tener como minimo:
   * 1 digito
   * 6 caracteres
   * y como minimo una minuscula.
   * ^(?=.{6,}$)((?=.*[a-z])(?=.*\d).+)$
   */

  const onSubmit = async (values): Promise<void> => {
    // console.log('FORM', form)
    if (values.password !== values.password2) {
      addAlert({
        message: 'Contraseñas no coinciden',
        status: 'error',
      })
      return
    }

    if (/^(?=.{6,}$)((?=.*[a-z])(?=.*\d).+)$/.test(values.password)) {
      let s3InfoResponse: { value: any } = { value: {} }
      const { planType, email, password, real_name, document } = values
      try {
        await dispatch(
          signUp({
            email: email?.toLowerCase(),
            password,
            name: real_name,
            uuid: uuidv4(),
            userPlan: planType,
          })
        )
        history.push('/registro_quinto')
      } catch (err: any) {
        if (err.code === 'UsernameExistsException') {
          addAlert({
            message: 'Correo ya existente',
            status: 'error',
          })
        }
      }

      // let token

      // try {
      //   console.log("email", email)
      //   console.log("password", password)
      //   const result: any = await dispatch(signIn({ email, password }))
      //   console.log("result...", result)
      //   // console.log('response sign in...', result)
      //   token = jwtDecode(result.access_token)
      // } catch (err) {

      // }

      // let date = new Date()
      // date.setMonth(date.getMonth() + 1)

      // let body = {
      //   businessSocial: bussinesName,
      //   plan: planType,
      //   email,
      //   subscriptionEnd: date.toISOString().replace(/T.+/, ''),
      //   subscriptionType: 'MONTHLY',
      //   document,
      // }
      // try {
      //   await axios.post(`${server}/user/tenant`, body, {headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': token
      //   } })
      //   history.push('/registro_quinto')
      // } catch (err) {
      //   addAlert({
      //     message: 'Error al crear el usuario.',
      //     status: 'error',
      //   })
      // }
      // dispatch({
      //   type: AUTH_USER_FIRSTSIGNUP,
      //   payload: { email: values.email, password: values.password },
      // })
      // history.push('/registro_segundo')
      return
    }

    addAlert({
      message:
        'Contraseña inválida, debe de poseer: al menos 1 digito, 6 caracteres y 1 minuscula',
      status: 'error',
    })
  }

  return (
    <div className="overflow-hidden">
      <Modal
        display={showModal}
        onClose={() => setShowModal(false)}
        externalHeight={windowSize.innerHeight + 50}
      >
        <h1 className="text-lg mb-5">
          Acuerdo de Licencia de Usuario Final ("ALUF") de Zerux
        </h1>
        <label>
          Este Acuerdo de Licencia de Usuario Final ("ALUF") es un acuerdo legal
          entre usted y Waku Software LLC. Este acuerdo ALUF rige la adquisición
          y el uso de nuestro software Zerux ("Software") directamente de Waku
          Software LLC o indirectamente a través de un revendedor o distribuidor
          autorizado de Waku Software LLC (un "Revendedor"). Lea detenidamente
          este acuerdo ALUF antes de completar el proceso de registro y utilizar
          el software Zerux. Proporciona una licencia para usar el software
          Zerux y contiene información sobre la garantía y exenciones de
          responsabilidad. Si se registra para una prueba gratuita del software
          Zerux, este acuerdo ALUF también regirá esa prueba. Al hacer clic en
          "aceptar" y/o usar el software Zerux, confirma que acepta el software
          y acepta quedar sujeto a los términos de este acuerdo ALUF. Si está
          celebrando este acuerdo ALUF en nombre de una empresa u otra entidad
          legal, declara que tiene la autoridad para obligar a dicha entidad y
          sus afiliados a estos términos y condiciones. Si no tiene dicha
          autoridad o si no está de acuerdo con los términos y condiciones de
          este acuerdo ALUF, no use el Software y no debe aceptar este acuerdo
          ALUF. Este acuerdo ALUF se aplicará únicamente al Software
          suministrado por Waku Software LLC independientemente de si se hace
          referencia o se describe otro software en este documento. Los términos
          también se aplican a las actualizaciones, suplementos, servicios
          basados en Internet y servicios de soporte de Waku Software LLC para
          el Software, a menos que otros términos acompañen a esos artículos en
          el momento de la entrega. Si es así, se aplican esas condiciones.
        </label>

        <h1 className="text-base mt-5 mb-2">Concesión de Licencia </h1>

        <label>
          Waku Software LLC por la presente le otorga una licencia personal,
          intransferible y no exclusiva para usar el software Zerux en sus
          dispositivos de acuerdo con los términos de este acuerdo ALUF. Tiene
          permiso para cargar el software Zerux en un dispositivo bajo su
          control (por ejemplo, una PC, computadora portátil, dispositivo móvil
          o tableta). Usted es responsable de asegurarse de que su dispositivo
          cumpla con los requisitos mínimos del software Zerux. No se le
          permite:
        </label>

        <div className="flex mt-2">
          {/* <BsFillCircleFill className="mr-3" size={25} /> */}
          <div className="mr-2">●</div>

          <label>
            Editar, alterar, modificar, adaptar, traducir o cambiar de otro modo
            la totalidad o parte del Software ni permitir que la totalidad o
            parte del Software se combine o se incorpore a cualquier otro
            software, ni descompilar, desensamblar o aplicar ingeniería inversa
            al Software o intentar hacer acciones similares
          </label>
        </div>

        <div className="flex mt-2">
          {/* <BsFillCircleFill className="mr-3" size={25} /> */}
          <div className="mr-2">●</div>

          <label>
            Reproducir, copiar, distribuir, revender o usar el Software para
            cualquier propósito comercial
          </label>
        </div>

        <div className="flex mt-2">
          {/* <BsFillCircleFill className="mr-3" size={25} /> */}
          <div className="mr-2">●</div>

          <label>
            Permitir que un tercero use el Software en nombre o en beneficio de
            un tercero
          </label>
        </div>

        <div className="flex mt-2">
          {/* <BsFillCircleFill className="mr-3" size={25} /> */}
          <div className="mr-2">●</div>

          <label>
            Usar el Software de cualquier manera que infrinja cualquier leyes
            locales, nacionales o internacionales{' '}
          </label>
        </div>

        <div className="flex mt-2">
          {/* <BsFillCircleFill className="mr-3" size={25} /> */}
          <div className="mr-2">●</div>

          <label>
            Usar el Software para cualquier propósito que Waku Software LLC
            considere un incumplimiento de este acuerdo.
          </label>
        </div>

        <h1 className="text-base mt-5 mb-2">Propiedad intelectual</h1>

        <label>
          Waku Software LLC conservará en todo momento la propiedad del
          Software. El Software (y los derechos de autor y otros derechos de
          propiedad intelectual de cualquier naturaleza en el Software,
          incluidas las modificaciones realizadas al mismo) son y seguirán
          siendo propiedad de Waku Software LLC. Waku Software LLC se reserva el
          derecho de otorgar licencias para usar el Software a terceros.
        </label>

        <h1 className="text-base mt-5 mb-2">Terminación</h1>

        <label>
        Este acuerdo ALUF entra en vigencia a partir de la fecha en que usa el Software por primera vez y continuará hasta que se rescinda. Puede rescindirlo en cualquier momento mediante notificación por escrito a Waku Software LLC. También terminará inmediatamente si no cumple con cualquier término de este acuerdo ALUF. Tras dicha rescisión, las licencias otorgadas por este acuerdo ALUF se rescindirán inmediatamente y usted acepta detener todo acceso y uso del Software. Las disposiciones que por su naturaleza continúen y sobrevivan sobrevivirán a cualquier rescisión de este acuerdo ALUF.
        </label>

        <h1 className="text-base mt-5 mb-2">Ley que rige</h1>

        <label>
        Este acuerdo de ALUF, y cualquier disputa que surja de o en relación con este acuerdo de ALUF, se regirá e interpretará de acuerdo con las leyes de Estados Unidos.
        </label>

        {/* • Reproducir,
          copiar, distribuir, revender o usar el Software para cualquier
          propósito comercial • Permitir que un tercero use el Software en
          nombre o en beneficio de un tercero • Usar el Software de cualquier
          manera que infrinja cualquier leyes locales, nacionales o
          internacionales • Usar el Software para cualquier propósito que Waku
          Software LLC considere un incumplimiento de este acuerdo. */}
      </Modal>

      {/* {showModal && (
        <div className="absolute h-full w-full flex justify-center items-center z-50" style={{background: 'rgba(0, 0, 0, 0.25)'}}>
          <div style={{height: 100, width: 100 }} className="shadow-2xl rounded bg-primaryGray-300">
            <h1 style={{color: 'white'}}>Hola</h1>
          </div>
        </div>
      )} */}

      <ExternalLayout>
        <div style={{ maxWidth: 400 }}>
          <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white">
            Registrar una cuenta
          </h1>

          {/* <p
        className="font-normal text-sm mb-2 text-primary-700 dark:text-primary-200"
        style={{ opacity: 0.5 }}
      >
        Paso 1 de 5
      </p> */}

          <div className="w-96">
            <p className="font-normal text-gray-400 text-sm mb-2">
              Ingresa tus datos para crear tus credenciales de acceso
            </p>
          </div>

          <Form form={form} onSubmit={onSubmit} classes={`gap-x-3`}>
            <FormItem
              name="planType"
              rules={{ required: 'Es necesario el campo' }}
              classes="col-span-12"
              defaultValue={plansType[1]}
            >
              <Select options={plansType} label="Tipo de Plan" />
            </FormItem>

            <FormItem
              classes="col-span-12 my-2"
              name="email"
              rules={{ required: 'Ingrese su usuario' }}
            >
              <InputText
                label="Correo electrónico"
                isUpperValue={false}
                onCheckIfExist={async () => {
                  // let response: any = await axios.get(
                  //   `${server}/user/tenant/check?email=${
                  //     form.getValues().email?.toLowerCase()
                  //   }`
                  // )

                  let ifExist = await authInstance.userExists(form.getValues().email?.toLowerCase())

                  if (ifExist) {
                    setEmailAlreadyExist(true)
                    form?.setError('email', {
                      type: 'manual',
                      message: 'Email ya existente',
                    })
                  } else {
                    setEmailAlreadyExist(false)
                    form?.clearErrors('email')
                  }
                }}
              />
            </FormItem>

            <FormItem
              classes="col-span-12 my-2"
              name="password"
              rules={{ required: 'Ingrese contraseña' }}
            >
              <InputText label="Contraseña" password isUpperValue={false} />
            </FormItem>

            <FormItem
              classes="col-span-12 my-2"
              name="password2"
              rules={{ required: 'Ingrese contraseña' }}
            >
              <InputText
                label="Confirmar contraseña"
                password
                isUpperValue={false}
              />
            </FormItem>

            {/* <FormItem
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            defaultValue={docs[0]}
            classes="col-span-3"
          >
            <Select options={docs} label="Tipo" />
          </FormItem>

          <FormItem
            name="document.document"
            classes="col-span-9"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText isUpperValue={false} label="Documento" maxLength={10} />
          </FormItem> */}

            <FormItem
              classes="col-span-12 my-2"
              name="real_name"
              rules={{ required: 'Ingrese nombre y apellido' }}
            >
              <InputText label="Tu nombre y apellido" isUpperValue={false} />
            </FormItem>

            <div className="col-span-12">
              <div className="flex">
                <input
                  type="checkbox"
                  style={{ marginRight: 10 }}
                  onClick={() => setAgree((prevState) => !prevState)}
                />
                {/* <div
                style={{
                  height: 12,
                  width: 12,
                  backgroundColor: '#006AEA',
                  borderRadius: 20,
                }}
                onClick={() => setAgree((prevState) => !prevState)}
                className="flex justify-center items-center"
              >
                {agree && (
                  <div
                    style={{
                      height: 6,
                      width: 6,
                      backgroundColor: 'white',
                      borderRadius: 20,
                    }}
                  ></div>
                )}
              </div> */}
                <p
                  className="ml-1 text-primary-1400 dark:text-primary"
                  style={{ fontWeight: 600 }}
                  onClick={() => setAgree((prevState) => !prevState)}
                >
                  Estoy de acuerdo con los términos y condiciones
                </p>

                {/* <Tooltip title='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco'> */}
                <FaRegQuestionCircle
                  style={{ marginLeft: 10 }}
                  className="cursor-pointer"
                  onClick={() => setShowModal(true)}
                />
                {/* </Tooltip> */}
              </div>
            </div>

            <Button
              type="primary"
              classes="col-span-12 mt-6 font-semibold tracking-wide"
              htmlType="submit"
              disabled={!agree || emailAlreadyExist}
              // disabled={true}
            >
              Continuar
            </Button>
          </Form>
        </div>
      </ExternalLayout>
    </div>
  )
}

export default RegisterFirst
